import { render } from "./invalidTokenPage.vue?vue&type=template&id=0a9e5b1f&scoped=true&ts=true"
import script from "./invalidTokenPage.vue?vue&type=script&lang=ts"
export * from "./invalidTokenPage.vue?vue&type=script&lang=ts"

import "./invalidTokenPage.vue?vue&type=style&index=0&id=0a9e5b1f&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9e5b1f"]])

export default __exports__